import React from 'react';

interface AlertProps {
  children: React.ReactNode;
  type: 'success' | 'danger' | 'warning' | 'info';
  className?: string;
}

const Alert: React.FC<AlertProps> = ({ children, type, className = '' }) => {
  return (
    <div className={`alert alert-${type} ${className}`}>
      {children}
    </div>
  );
};

export default Alert; 